import { render, staticRenderFns } from "./patientsPortalSetup.vue?vue&type=template&id=5d5d67a4&"
import script from "./patientsPortalSetup.vue?vue&type=script&lang=js&"
export * from "./patientsPortalSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports